{
  "version": 1,
  "asset_id": "3e636870-251b-4e1f-a09a-0582f19b95ee",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/3e636870-251b-4e1f-a09a-0582f19b95ee/beverly-hills-shingle-roof-tear-off-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/3e636870-251b-4e1f-a09a-0582f19b95ee/beverly-hills-shingle-roof-tear-off-480w.webp",
  "original_filename": "beverly-hills-shingle-roof-tear-off-480w.webp",
  "size": 30916,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:16Z"
}
